import { request, postFormData, axiosInstance } from "../helper/axios_helper";

// ─── Suites ───────────────────────────────────────────────────
export const getAllUISuites = () =>
  request("GET", "/api/auth/ui/suite/fetch/all");

export const getUISuiteById = (suiteId) =>
  request("GET", `/api/auth/ui/suite/fetch/${suiteId}`);

export const createUISuite = (suite) =>
  request("POST", "/api/auth/ui/suite/create", suite);

export const updateUISuite = (suiteId, suite) =>
  request("PUT", `/api/auth/ui/suite/update/${suiteId}`, suite);

export const deleteUISuite = (suiteId) =>
  request("DELETE", `/api/auth/ui/suite/delete/${suiteId}`);

// ─── Steps ────────────────────────────────────────────────────
export const getUISteps = (suiteId) =>
  request("GET", `/api/auth/ui/suite/${suiteId}/steps`);

export const addUIStep = (suiteId, step) =>
  request("POST", `/api/auth/ui/suite/${suiteId}/step/add`, step);

export const updateUIStep = (suiteId, stepId, step) =>
  request("PUT", `/api/auth/ui/suite/${suiteId}/step/update/${stepId}`, step);

export const deleteUIStep = (suiteId, stepId) =>
  request("DELETE", `/api/auth/ui/suite/${suiteId}/step/delete/${stepId}`);

export const reorderUISteps = (suiteId, order) =>
  request("PUT", `/api/auth/ui/suite/${suiteId}/steps/reorder`, order);

// ─── Run ──────────────────────────────────────────────────────
// runBy is NOT sent from frontend — backend extracts from JWT token
export const runUISuite = (suiteId) =>
  request("POST", `/api/auth/ui/suite/${suiteId}/run`);

// Citrix data-driven run — body: { environment, rows: [ {col: val}, ... ] }
export const runCitrixSuite = (suiteId, body) =>
  request("POST", `/api/auth/ui/suite/${suiteId}/run/citrix`, body || {});

// ─── Results ──────────────────────────────────────────────────
export const getAllUIResults = () =>
  request("GET", "/api/auth/ui/result/fetch/all");

export const getUIResultsBySuite = (suiteId) =>
  request("GET", `/api/auth/ui/result/fetch/suite/${suiteId}`);

export const getUIResultById = (resultId) =>
  request("GET", `/api/auth/ui/result/fetch/${resultId}`);

export const getUIStepResults = (resultId) =>
  request("GET", `/api/auth/ui/result/fetch/${resultId}/steps`);

export const getUIResultByJobId = (jobId) =>
  request("GET", `/api/auth/ui/result/fetch/job/${jobId}`);

// ─── Action metadata ──────────────────────────────────────────
// engine = "WEB" (Playwright) | "CITRIX" (OculiX image/OCR)
export const getUIActions = (engine = "WEB") =>
  request("GET", `/api/auth/ui/actions?engine=${engine}`);

// ─── Citrix data-driven dataset + reference images ─────────────
// Parse an uploaded .xlsx → { columns, rows, rowCount } (builder preview)
export const parseUIDataset = (file) => {
  const fd = new FormData();
  fd.append("fileUpload", file);
  return postFormData("/api/auth/ui/dataset/parse", fd);
};

// Same, but the .xlsx lives at a path on the ARC server
export const parseUIDatasetFromPath = (serverPath) =>
  request("POST", "/api/auth/ui/dataset/parse-path", { serverPath });

// Upload a reference image for a Citrix step → { imageKey }
export const uploadUIAsset = (file) => {
  const fd = new FormData();
  fd.append("fileUpload", file);
  return postFormData("/api/auth/ui/asset/upload", fd);
};

// Fetch a stored reference image (auth-carrying) → object URL for <img src>
export const getUIAssetUrl = (key) =>
  axiosInstance
    .get(`/api/auth/ui/asset/read?key=${encodeURIComponent(key)}`, {
      responseType: "blob",
    })
    .then((res) => URL.createObjectURL(res.data));

// ─── Job queue ────────────────────────────────────────────────
export const getActiveJobs = (hours = 24, runBy = "") => {
  const params = new URLSearchParams({ hours });
  if (runBy) params.append("runBy", runBy);
  return request("GET", `/api/auth/job/queue/active?${params.toString()}`);
};
